import React, { useState, useEffect, useRef } from 'react';
import { Typography, Space } from 'antd';

const { Text } = Typography;

const formatTime = (seconds) => {
    const hrs = String(Math.floor(seconds / 3600)).padStart(2, '0');
    const mins = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
    const secs = String(seconds % 60).padStart(2, '0');
    return `${hrs}:${mins}:${secs}`;
};

export const Chronometer = ({ size = 22 }) => {
    const [seconds, setSeconds] = useState(0);
    const intervalRef = useRef(null);

    useEffect(() => {

        intervalRef.current = setInterval(() => {
            setSeconds((prev) => prev + 1);
        }, 1000);

        return () => clearInterval(intervalRef.current);
    }, []);


    return (
        <Space direction="vertical" align="center">
            <Text strong style={{ fontSize: size }}>
                {formatTime(seconds)}
            </Text>
        </Space>
    );
};